import { useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import useViewDepartment from 'src/hooks/useViewDepartments';
import DepartmentGLCodeCell from 'src/sections/view_department/tableToolbar/DepartmentGLCodeCell';

export const useGLCodeColumn = () => {
  const { t } = useViewDepartment();
  const glCodeColumns: GridColumn<any>[] = useMemo(
    () => [
      {
        field: 'selected',
        title: '',
        className: 'text-center',
        filter: 'boolean',
        menu: false,
        dataType: 'fixed',
        sortable: false,
      },
      {
        field: 'name',
        title: t('GL Codes'),
        component: DepartmentGLCodeCell,
        filter: 'text',
      },
    ],
    [t]
  );
  return glCodeColumns;
};
